import React from "react";
import Navbar from "../components/Navbar";
import EARTH from "../components/EARTH";
import Footer from "../components/Footer";

var Earth = () => {
  return (
    <>
      <Navbar />
      <EARTH />
      <Footer />
    </>
  );
};

export default Earth;
